import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { EGG_LABELS } from './constants';

export const PreciosDialog = ({ open, onOpenChange, form, setForm, saving, onSave }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent data-testid="modal-precios">
      <DialogHeader>
        <DialogTitle style={{ fontFamily: 'Space Grotesk' }}>
          Configurar Precios por Tipo de Huevo
        </DialogTitle>
      </DialogHeader>
      <div className="space-y-3 py-4">
        {Object.entries(EGG_LABELS).map(([key, label]) => (
          <div key={key} className="flex items-center gap-3">
            <Label className="w-24 text-sm">{label}</Label>
            <div className="flex items-center gap-1 flex-1">
              <span className="text-muted-foreground">$</span>
              <Input
                type="number"
                inputMode="decimal"
                step="0.01"
                min="0"
                placeholder="0.00"
                value={form[key] || ''}
                onChange={(e) => setForm({ ...form, [key]: e.target.value })}
                className="h-10 tabular-nums"
              />
            </div>
          </div>
        ))}
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
        <Button onClick={onSave} disabled={saving} data-testid="btn-guardar-precios">
          {saving ? 'Guardando...' : 'Guardar Precios'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
